/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-03 15:40:45
 * @LastEditors: K
 * @LastEditTime: 2022-09-06 10:10:45
 */
import { unwrapResult } from '@reduxjs/toolkit';
import {Button, Col, notification, Row, Table} from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../../app/store';
import { EditableList } from '../../../compnents/list/EditableList';
import { Label } from '../../../compnents/widgets/Label';
import { UpdateTime } from '../components/time';
import { getDataList, getTableList } from '../monitoringPageSlice';
import styles from './monitoringPage.module.css'
import {getLiveTenantsExport} from "../../tenant/tenantSlice";

interface MonitoringPageProps {
  state: string
}

export const MonitoringPage = ({ state }: MonitoringPageProps): ReactElement => {

  const dispatch = useDispatch<RootDispatch>()

  const [pageLoading, setPageLoading] = useState(false)  //表格 loading
  const [btnLoading, setBtnLoading] = useState(false)  //表格 loading

  const [page, setPage] = useState([])

  const [topList, setTopList] = useState<any>()

  const [bottomList, setBottomList] = useState<any>()

  const result = (str: string) => {
    return (str == '机构数据' || str == '用户数据' || str == '患者就诊' || str == '结算')
  }

  const bgcFn = (type: number) => {
    switch (type) {
      case 1:
        return '#e2ecff'
      case 2:
        return '#ffd9e8'
      case 3:
        return ' #e5ffeb'
      default:
        return '#fff';
    }
  }
  const borderFn = (type: number) => {
    switch (type) {
      case 1:
        return '1px solid #87affa'
      case 2:
        return '1px solid  #ff70a9'
      case 3:
        return '1px solid  #93d678'
      default:
        return '#fff';
    }
  }



  useEffect(() => {
    setPageLoading(true)
    dispatch(getTableList())  //表格数据
      .then(unwrapResult)
      .then((t: any) => {
        setPage(t)
      })
      .finally(() => setPageLoading(false))
    dispatch(getDataList())  //数据看板数据
      .then(unwrapResult)
      .then((res: any) => {
        setBottomList(Object.entries(res).filter((item: any) => !result(item[0])))
        setTopList(Object.entries(res).filter((item: any) => result(item[0])))
      })


  }, [])

  useEffect(() => {
    sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])

  const ListExport = () => {
    setBtnLoading(true);
    dispatch(getLiveTenantsExport())
      .then(unwrapResult)
      .then((res: any) => {
        console.log(res, 'res')
        const content = res
        const blob = new Blob([content])
        const fileName = '近14天活跃机构.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          navigator.msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        setBtnLoading(false);
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        console.log('失败')
        setBtnLoading(false);
      }).finally(()=>{
        setBtnLoading(false);
      })
  }

  return (
    <div className={styles.content}>
      {/* <UpdateTime time={'fsdg'} /> */}
      <Row gutter={[30, 30]} style={{ marginBottom: 30 }}>
        <Col span={12}>
          <Row gutter={[30, 30]}>
            {
              topList && topList.map((item: any) => {
                return (
                  <Col span={12} key={item[0]}>
                    <div className={styles.itemContent} style={{ background: bgcFn(item[1][0].type), border: borderFn(item[1][0].type) }}>
                      <Label ml={'20px'} label={item[0]} />

                      {item[1].map((val: any) => {

                        return (
                          <div style={{ paddingLeft: '25px' }} key={val.id}>
                            <span className={styles.listContentItemText}>{val.itemName}: </span>
                            <span className={styles.listContentItemTextValue}>{val.itemValue}</span>
                            <span className={styles.listContentItemTextNum}> ({val.highlightValue})</span>
                            {val.itemName == '活跃机构总数'?
                              <Button className={styles.listContentItemTextNum} style={{marginLeft:5,cursor:"pointer"}} type='link' loading={btnLoading}
                                onClick={() => {
                                  ListExport()
                                }}
                                >
                                导出

                              </Button>
                           :''}
                          </div>
                        )
                      })}
                    </div>

                  </Col>
                )
              })
            }
          </Row>
        </Col>

        <Col span={12}>
          <div className={styles.tableWrap}>
            <Label ml={'20px'} label="机构类型分布" />

            <Table
              className={styles.table}
              scroll={{ y: 200 }}
              dataSource={page}
              pagination={false}
              loading={pageLoading}
              columns={[
                {
                  title: '机构类型',
                  dataIndex: 'categoryName',
                  key: 'categoryName',
                  align: 'center',
                  width: 100
                },
                {
                  title: '机构总数',
                  dataIndex: 'subCnt',
                  key: 'subCnt',
                  align: 'center',
                  width: 100
                },
                {
                  title: '活跃机构数',
                  dataIndex: 'activeCnt',
                  key: 'activeCnt',
                  align: 'center',
                  width: 100
                },
              ]}
            />
          </div>
        </Col>
      </Row>

      <Row gutter={[30, 30]}>

        {bottomList && bottomList.map((item: any) => {
          return (
            <Col span={6} key={item[0]}>
              <div className={styles.itemContent2} style={{ background: bgcFn(item[1][0].type), border: borderFn(item[1][0].type) }}>
                <Label ml={'20px'} label={item[0]} />
                {item[1].map((val: any) => {
                  return (
                    <div style={{ paddingLeft: '25px' }} key={val.id}>
                      <span className={styles.listContentItemText}>{val.itemName}: </span>
                      <span className={styles.listContentItemTextValue}>{val.itemValue}</span>
                      <span className={styles.listContentItemTextNum}> ({val.highlightValue})</span>
                    </div>
                  )
                })}
              </div>
            </Col>
          )
        })}
      </Row>
    </div>
  );
}



